export const SITE_NAME = "Duffy's Furniture";
export const SITE_DESCRIPTION = "Quality furniture for every space";
export const LOGO_WHITE_BG = "https://res.cloudinary.com/dh0ehlpkp/image/upload/v1771416217/downlopoad_6_vqxqp8.png";
export const LOGO_NONE_BG = "https://res.cloudinary.com/dh0ehlpkp/image/upload/v1771416414/downlopoad_ji_6_uygtfn.png";



export const HERO_IMG = "https://res.cloudinary.com/dvmuf6jfj/image/upload/v1757264154/Usave/unsplash_qB0ikuBJtHU_xonh35.jpg";
